import { env } from '@/env'

/**
 * Build a logo.dev CDN URL for a tenant's real marketing domain.
 *
 * `null` or empty domains return `""`, signalling the caller (LogoLayer)
 * to skip rendering an `<img>` and show the graphite letter fallback
 * directly — the guaranteed-stable look for opt-out tenants.
 *
 * `format=png` is required: logo.dev's default webp loses alpha on
 * Safari, which makes transparent brand marks render on a black square.
 */
export function tenantLogoUrl(
  logoDomain: string | null | undefined,
  size = 128,
): string {
  if (!logoDomain) return ''
  const domain = encodeURIComponent(logoDomain)
  const token = encodeURIComponent(env.VITE_LOGO_DEV_TOKEN)
  return `https://img.logo.dev/${domain}?token=${token}&size=${size}&format=png`
}
